<template>
  <div class="el-col-24">
    <h5 class="warp-title">问答评价详情</h5>
    <div class="search">
      <el-form :inline="true" :model="searchForm" size="small">
        <el-form-item label="平台">
          <el-select v-model="searchForm.platformId" placeholder="平台">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item, index) in specialPlatformList" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间">
          <el-date-picker
            v-model="time"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="问题">
          <el-input v-model="searchForm.content" placeholder="请输入问题关键字" clearable></el-input>
        </el-form-item>
        <el-form-item label="排序方式">
           <el-radio-group v-model="searchForm.sort">
              <el-radio :label="1">倒叙</el-radio>
              <el-radio :label="0">正序</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit" :loading="isSearchLoading">查询</el-button>
          <el-button @click="clear">清空选项</el-button>
          <el-button @click="export1">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableData" border class="el-table">
        <el-table-column prop="content" label="问题" align="center"></el-table-column>
        <el-table-column label="平台" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.platformName }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="count" label="问题评价次数" align="center"></el-table-column>
        <el-table-column label="是否解决问题" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.isItSolved === 1">是</span>
            <span v-if="scope.row.isItSolved === 2">否</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="count" label="问题评价次数" align="center"></el-table-column>
        <el-table-column prop="validCount" label="有帮助次数" align="center"></el-table-column>
        <el-table-column prop="invalidCount" label="没帮助次数" align="center"></el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searchForm.currentPage"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="searchForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      class="mt20"
      align="right"
      background>
    </el-pagination>
  </div>
</template>

<script>
import {queryProblemHelpRecordCountPage, exportProblemHelpRecordCountList} from '../../api/statistics/index'
export default {
  name: 'ProblemEvaluation',
  created () {
    this.initData()
  },
  computed: {
    specialPlatformList () {
      return this.$store.state.Auth.specialPlatformList
    }
  },
  data () {
    return {
      isSearchLoading: false,
      time: [this.$route.query.startTime || '', this.$route.query.endTime || ''],
      total: 0,
      tableData: [],
      searchForm: {
        content: '',
        platformId: '',
        startTime: this.$route.query.startTime || '',
        endTime: this.$route.query.endTime || '',
        sort: 1,
        pageSize: 10,
        currentPage: 1
      }
    }
  },
  watch: {
    time () {
      if (this.time && this.time.length === 2) {
        this.searchForm.startTime = this.time[0]
        this.searchForm.endTime = this.time[1]
      } else {
        this.searchForm.startTime = ''
        this.searchForm.endTime = ''
      }
    }
  },
  methods: {
    export1 () {
      let data = {
        content: this.searchForm.content,
        platformId: this.searchForm.platformId,
        startTime: this.searchForm.startTime,
        endTime: this.searchForm.endTime,
        sort: this.searchForm.sort
      }
      exportProblemHelpRecordCountList(data).then(res => {
        if (res.data.resultCode === 0) {
          window.open(res.data.resultData.fileDownLoadUrl)
        } else {
          this.$message.error(res.data.resultMessage)
        }
      })
    },
    clear () {
      this.time = ''
      this.searchForm = {
        content: '',
        platformId: '',
        startTime: '',
        endTime: '',
        sort: 1,
        pageSize: 10,
        currentPage: 1
      }
      this.initData()
    },
    onSubmit () {
      this.searchForm.currentPage = 1
      this.initData()
    },
    handleSizeChange (pageSize) {
      this.searchForm.currentPage = 1
      this.searchForm.pageSize = pageSize
      this.initData()
    },
    handleCurrentChange (currentPage) {
      this.searchForm.currentPage = currentPage
      this.initData()
    },
    initData () {
      let data = {
        platformId: this.searchForm.platformId,
        content: this.searchForm.content,
        startTime: this.searchForm.startTime,
        endTime: this.searchForm.endTime,
        currentPage: this.searchForm.currentPage,
        pageSize: this.searchForm.pageSize,
        sort: this.searchForm.sort
      }
      this.isSearchLoading = true
      queryProblemHelpRecordCountPage(data).then(res => {
        this.isSearchLoading = false
        if (res.data.resultCode === 0) {
          this.tableData = res.data.resultData
          this.total = res.data.totalCount
        } else {
          this.$message.error(res.data.resultMessage)
        }
      }).catch(() => {
        this.isSearchLoading = false
      })
    }
  }
}
</script>

<style>
/* .pagination {
  float: right;
} */
</style>



// WEBPACK FOOTER //
// src/components/Statistics/ProblemEvaluation.vue